import { Box, Typography } from "@mui/material";

export interface NextStepProps {
  n: number;
  title: string;
  description: string;
}

/** Paso numerado del flujo de formalización: cuadro con número en `primary.main` + título + descripción. */
export const NextStep = ({ n, title, description }: NextStepProps) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", gap: "14px" }}>
    <Box
      sx={{
        flexShrink: 0,
        width: 28,
        height: 28,
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "tokens.pageBg",
      }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "primary.main" }}>{n}</Typography>
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: "primary.dark", lineHeight: 1.35 }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: 12.5, color: "tokens.textTertiary", lineHeight: 1.5, mt: "2px" }}>
        {description}
      </Typography>
    </Box>
  </Box>
);
